<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>质量监控</el-breadcrumb-item>
			<el-breadcrumb-item>缺陷分析</el-breadcrumb-item>
		</el-breadcrumb>
		<tool-bar v-on:select="handleSelectJT" :timerVisible="false" />
		<div class="monitor_section" v-if="showDeviceInfo" v-loading="loading">
			<div class="header">
				<h3>
					设备类型：<span style="color:red">{{ deviceTypeText }}</span>
				</h3>
				<el-button style="float: right; margin-bottom:10px;" icon="el-icon-circle-plus-outline" type="primary" @click="add">添加</el-button>
				<div class="clearfix"></div>
			</div>
			<div>
				<el-table border :data="defectAnalyzeData" v-loading="loading">
					<el-table-column type="index" width="60" label="序号"></el-table-column>
					<el-table-column prop="defect_name" width="120" label="缺陷类型"></el-table-column>
					<el-table-column prop="opinion" label="规避意见"></el-table-column>
					<el-table-column prop="name" width="200" label="名称"></el-table-column>
					<el-table-column width="160" label="操作">
						<template slot-scope="scope">
							<el-button type="text" icon="el-icon-edit" @click="edit(scope.row)">编辑</el-button>
							<el-button type="text" icon="el-icon-delete" @click="deleteDefect(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<el-dialog :title="titleDiago" :visible.sync="dialogVisible" width="500px">
			<el-form ref="form" :rules="rules" :model="form" label-position="top">
				<el-form-item label="缺陷类型" prop="defect_name">
					<el-select v-model="form.defect_name" placeholder="请选择">
						<el-option v-for="item in filtersShow" :key="item._id.$oid" :label="item.name" :value="item.name"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="名称" prop="name">
					<el-input v-model="form.name" placeholder="输入名称" maxlength="150" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="意见内容" prop="opinion">
					<el-input type="textarea" v-model="form.opinion" :rows="5" placeholder="输入意见" maxlength="500" show-word-limit></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" :loading="saving" @click="submitForm('form')">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import ToolBar from './ToolBar'
	import { defectTypeRequest } from '@/network/requests/defectType'
	import { defectAnalyzeRequest } from '@/network/requests/defectAnalyze'

	export default {
		components: {
			ToolBar,
		},
		data() {
			this.device_types = [
				{
					value: 0,
					label: '柔印机',
				},
				{
					value: 1,
					label: '胶印机',
				},
				{
					value: 2,
					label: '凹印机',
				},
				{
					value: 3,
					label: '热复合机',
				},
				{
					value: 4,
					label: '冷复合机',
				},
				{
					value: 5,
					label: '复卷机',
				},
				{
					value: 6,
					label: '其他',
				},
			]

			return {
				num: 0,
				form: {
					opinion: '',
				},
				showDeviceInfo: false,
				defectTypes: [],
				currentJT: {},
				dialogVisible: false,
				defectAnalyzeData: [],
				data: [],
				loading: false,
				titleDiago: '',
				rules: {
					defect_name: [{ required: true, message: '请选择缺陷类型', trigger: 'blur' }],
					name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
				},
				saving: false,
			}
		},
		filters: {},
		computed: {
			filtersShow() {
				var containt = []
				this.defectTypes.findIndex((k, v) => {
					var index = this.defectAnalyzeData.findIndex(t => t.defect_name == k.name)
					if (index == -1) {
						containt.push(k)
					}
				})
				return containt
			},
			jt_id() {
				var jt_id = ''
				if (this.currentJT._id) {
					jt_id = this.currentJT._id.$oid
				}

				return jt_id
			},
			/**
			 * 设备类型。
			 */
			deviceType() {
				if (this.currentJT) {
					console.log("type123456",this.currentJT.type)
					return this.currentJT.type
				}

				return 0
			},
			deviceTypeText() {
				if (this.deviceType>=0) {
					var t = this.device_types.find(t => t.value == this.deviceType)
					console.log("label",t.label)

					return t.label
				}
				return 0
			},
		},
		watch: {
			deviceType(val) {
				if (val >= 0) {
					this.loading = true
					console.log('deviceType', val)
					this.loadData()
				} else {
					this.defectAnalyzeData = []
				}
			},
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						this.save()
					} else {
						return false
					}
				})
			},
			/**
			 * 查看机台状态。
			 */
			handleSelectJT(jtInfo) {
				this.showDeviceInfo = true
				this.currentJT = jtInfo
			},
			save() {
				this.saving = true

				//保存缺陷分析。
				defectAnalyzeRequest
					.upload({ ...this.form })
					.then(res => {
						this.loadData()
					})
					.finally(() => {
						this.dialogVisible = false

						setTimeout(() => {
							this.saving = false
						}, 1000)
					})
			},
			/**
			 * 编辑打开窗口
			 */
			edit(row) {
				this.titleDiago = '编辑'
				this.dialogVisible = true
				this.form = { ...row }
			},
			/**
			 * 删除缺陷分析
			 */
			deleteDefect(row) {
				defectAnalyzeRequest
					.deleteById(row._id.$oid)
					.then(res => {
						this.$message({
							type: 'success',
							message: '删除成功',
						})
						this.loadData()
					})
					.catch(err => {
						this.$message({
							type: 'error',
							message: '异常信息,请重试' + err.message,
						})
					})
			},
			/**
			 * 添加打开窗口
			 */
			add() {
				this.form = {
					device_type: this.deviceType,
				}
				this.titleDiago = '添加'
				this.dialogVisible = true
				// this.form = { ...row }
			},
			/**
			 * 加载数据集
			 */
			loadData() {
				this.loading = true
				defectAnalyzeRequest
					.queryAll({ device_type: this.currentJT.type })
					.then(res => {
						this.defectAnalyzeData = res
					})
					.finally(() => {
						this.loading = false
					})
			},
		},
		async created() {
			this.defectTypes = await defectTypeRequest.queryAll({ roll_id: 'sys' })
		},
	}
</script>

<style scoped>
	.form-table td,
	.form-table th {
		padding: 15px;
	}
</style>
